module.exports = __webpack_public_path__ + "img/11.87b8bf43.png";